import { css } from 'aphrodite/no-important';
import React, { FC, useEffect, useRef, useState } from 'react';
import { style } from './style';
import { DropdownDownIcon } from '../../util/icons';

interface LanguageProps {
  /**
   * Callback function to be called when user selects language.
   */
  onSelect: (language: string) => void;
  /**
   * Copies for Language Component
   */
  copy: any;
  /**
   * Styles for Language Component
   */
  languageStyles: any;
}

const Language: FC<LanguageProps> = ({
  onSelect,
  copy,
  languageStyles
}) => {


  const styles = style(languageStyles);
  const [opened, setOpened] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Close dropdown if clicked outside
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpened(false);
        }
      }
      if ( opened ) {
        document.addEventListener('touchstart', handleClickOutside);
        document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
        document.removeEventListener('touchstart', handleClickOutside);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref, opened]);
  }

  const selectLanguage = (languageId: string) => {
    setOpened(false);
    onSelect(languageId);
  };

  return (
    <div className={css(styles.langSelector)} ref={wrapperRef}>
      <p className={css(styles.langLabel)}>
        {copy.label}<DropdownDownIcon/>
      </p>
      <input className={css(styles.langTrigger)}
             checked={opened}
             type='checkbox'
             onChange={() => setOpened(!opened)}/>
      <div className={css(styles.langDropdown)} id='dropdown'>
        { copy.items.map( ( language: any) =>
          <p key={language.id}
             onClick={() => selectLanguage(language.id)}>{language.value}</p>
        )}
      </div>
    </div>
  );
};

export default Language;
